import React from 'react';
import VehicleInsuranceDocumentPreview from '../vehicles/VehicleInsuranceDocumentPreview';

export const getCargoProtectionVehicle = (driver) => {
    if (Number(driver?.type) !== 1 || !Array.isArray(driver?.vehicles)) {
        return null;
    }

    return driver.vehicles.find((vehicle) => (
        vehicle?.insurance_document?.available === true
    )) || driver.vehicles.find((vehicle) => vehicle?.id) || null;
};

const DriverCargoProtectionDocument = ({driver, enabled = true}) => {
    if (Number(driver?.type) !== 1) {
        return null;
    }

    const vehicle = getCargoProtectionVehicle(driver);

    return (
        <div className="col-md-6 mb-2" data-testid="cargo-protection-document">
            <div className="card p-2" align="center">
                Cargo Protection <br/>
                <VehicleInsuranceDocumentPreview
                    enabled={enabled}
                    imageAlt="Cargo Protection document preview"
                    label="Cargo Protection"
                    metadata={vehicle?.insurance_document}
                    vehicleId={vehicle?.id}
                />
            </div>
        </div>
    );
};

export default DriverCargoProtectionDocument;
